import {
  Box,
  Typography,
  IconButton,
  Menu,
  MenuItem,
  Avatar,
  Divider,
} from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function TopBar() {
  const navigate = useNavigate();
  const username = localStorage.getItem("username") || "Admin";
  const [snackbarOpen, setSnackbarOpen] = useState(false);
const [snackbarMessage, setSnackbarMessage] = useState("");


  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpen = (e) => setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleLogout = async () => {
  try {
    const accessToken = localStorage.getItem("accessToken");
    const refreshToken = localStorage.getItem("refreshToken");

    await axios.post(
      `${API_BASE_URL}/api/users/logout/`,
      { refresh: refreshToken },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    localStorage.clear();
    navigate("/");
  } catch (err) {
    console.error("Logout failed:", err);
    setSnackbarMessage("Logout failed. Please try again.");
    setSnackbarOpen(true);
  }
  handleClose();
};

  return (
    <Box
      sx={{
        height: 64,
        bgcolor: "#ffffff",
        px: 3,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        borderBottom: "1px solid #e5e7eb",
        boxShadow: "0 1px 6px rgba(0,0,0,0.06)",
        position: "sticky",
        top: 0,
        zIndex: 10,
      }}
    >
      {/* Left */}
      <Typography
        fontWeight="bold"
        fontSize="1rem"
        color="#0f172a"
      >
        Admin Control Panel
      </Typography>

      {/* Right */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
        <Box sx={{ textAlign: "right", lineHeight: 1 }}>
          <Typography fontWeight={600} fontSize="0.9rem">
            {username}
          </Typography>
          <Typography fontSize="0.75rem" color="text.secondary">
            Administrator
          </Typography>
        </Box>

        <IconButton onClick={handleOpen}>
          <Avatar
            sx={{
              bgcolor: "#1e3a8a",
              width: 38,
              height: 38,
              fontWeight: "bold",
              transition: "0.2s",
              "&:hover": {
                boxShadow: "0 0 0 3px rgba(30,58,138,0.25)",
              },
            }}
          >
            {username[0].toUpperCase()}
          </Avatar>
        </IconButton>

        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          PaperProps={{
            sx: {
              mt: 1,
              borderRadius: 2,
              minWidth: 160,
              boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
            },
          }}
        >
          <MenuItem disabled sx={{ fontSize: "0.85rem", opacity: 0.8 }}>
            Signed in as <b>&nbsp;{username}</b>
          </MenuItem>

          <Divider />

          <MenuItem onClick={handleLogout}>
            <LogoutIcon fontSize="small" sx={{ mr: 1 }} />
            Logout
          </MenuItem>
        </Menu>
      </Box>
    </Box>
  );
}

export default TopBar;
